var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultipleFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3523 2H12.0139C11.2986 2 10.5834 2.35763 10.0469 2.89409C9.51047 3.43054 9.15283 4.14581 9.15283 4.86108V27.7497C9.15283 28.465 9.51047 29.1802 10.0469 29.7167C10.5834 30.2531 11.2986 30.6108 12.0139 30.6108H29.538C30.2533 30.6108 30.9685 30.2531 31.505 29.7167C32.0414 29.1802 32.3991 28.465 32.3991 27.7497V10.0468L24.3523 2Z",
    stroke: "url(#paint0_linear_6_100)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.0138V34.9024C2 35.6176 2.35763 36.3329 2.89409 36.8694C3.43054 37.4058 4.14581 37.7634 4.86108 37.7634H22.3852M23.4581 2V10.9409H32.3989",
    stroke: "url(#paint1_linear_6_100)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_100",
    x1: 20.776,
    y1: 2,
    x2: 20.776,
    y2: 30.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_100",
    x1: 17.1995,
    y1: 2,
    x2: 17.1995,
    y2: 37.7634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066D9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleFile);
export default __webpack_public_path__ + "static/media/multiple-file.113ec8ae858d194adf3a31f6f37943c7.svg";
export { ForwardRef as ReactComponent };